import type { Translations } from '../../../types'

const profileTeamMessages: Translations = {
  "profile.team.title": "Team e ruoli",
  "profile.team.subtitle": "Utenti autorizzati all'area admin.",
  "profile.team.count": "{{count}} membri",
  "profile.team.count.filtered": "{{visible}} su {{total}} membri",
  "profile.team.refresh": "Aggiorna elenco",
  "profile.team.refreshing": "Aggiornamento...",
  "profile.team.actions.new": "Nuovo membro",
  "profile.team.search.placeholder": "Cerca utenti per nome, username, email o ruolo...",
  "profile.team.lastLogin": "Ultimo login",
  "profile.team.assignedRoles": "Ruoli assegnati",
  "profile.team.saveRoles": "Salva ruoli",
  "profile.team.savingRoles": "Salvataggio...",
  "profile.team.empty.loading": "Caricamento membri in corso...",
  "profile.team.emptyTitle": "Nessun utente",
  "profile.team.empty": "Ancora nessun membro aggiunto. Usa il form qui sotto per creare il primo.",
  "profile.team.empty.searchTitle": "Nessun utente trovato",
  "profile.team.empty.searchSubtitle": "Prova a modificare i criteri di ricerca.",
  "profile.team.table.user": "Utente",
  "profile.team.table.roles": "Ruoli",
  "profile.team.table.capabilities": "Capabilities",
  "profile.team.table.lastLogin": "Ultimo accesso",
  "profile.team.table.actions": "Azioni",
  "profile.team.edit": "Modifica",
  "profile.team.delete": "Elimina",
  "profile.team.deleting": "Eliminazione...",
  "profile.team.pagination.summary": "Mostra {{from}}-{{to}} di {{total}}",
  "profile.team.pagination.prev": "Precedente",
  "profile.team.pagination.next": "Successivo",
  "profile.team.confirmDelete": "Sei sicuro di voler eliminare questo utente? L'azione è irreversibile.",
  "profile.team.error.deleteUser": "Errore durante l'eliminazione dell'utente",
  "profile.team.error.updateCapabilities": "Errore durante l'aggiornamento dei permessi",
  "profile.team.newMember.title": "Nuovo membro",
  "profile.team.newMember.subtitle": "Crea credenziali per un nuovo admin o editor assegnando subito i ruoli necessari.",
  "profile.team.newMember.username": "Username",
  "profile.team.newMember.displayName": "Nome visualizzato",
  "profile.team.newMember.email": "Email",
  "profile.team.newMember.password": "Password iniziale",
  "profile.team.newMember.roles": "Ruoli",
  "profile.team.newMember.submit": "Invita membro",
  "profile.team.newMember.submitting": "Creazione...",
  "profile.team.newRole.title": "Nuovo ruolo",
  "profile.team.newRole.subtitle": "Personalizza i ruoli per organizzare il tuo team editoriale.",
  "profile.team.newRole.label": "Label",
  "profile.team.newRole.name": "Identificativo (senza spazi)",
  "profile.team.newRole.description": "Descrizione",
  "profile.team.newRole.submit": "Crea ruolo",
  "profile.team.newRole.submitting": "Creazione...",
  "profile.team.error.missingRoleName": "Indica almeno il nome del ruolo.",
  "profile.team.error.missingUser": "Username e password sono obbligatori.",
  "profile.team.capabilities.title": "Gestisci capabilities",
  "profile.team.capabilities.subtitle": "Personalizza i permessi specifici per questo utente. I permessi dai ruoli sono contrassegnati.",
  "profile.team.capabilities.fromRole": "Dal ruolo",
  "profile.team.capabilities.fromRoleShort": "da ruoli",
  "profile.team.capabilities.all": "Tutte",
  "profile.team.capabilities.none": "Nessuna",
  "profile.team.capabilities.custom": "Custom",
  "profile.team.capabilities.manage": "Gestisci permessi",
  "profile.team.capabilities.save": "Salva",
  "profile.team.capabilities.saving": "Salvataggio...",
  "profile.team.capabilities.cancel": "Annulla",
}

export default profileTeamMessages
